import Splide from '@splidejs/splide';

(function () {
  'use strict';

  const selectors = {
    splide: '.js-stage'
  };

  const init = () => {
    const splides = document.querySelectorAll(selectors.splide);
    splides.forEach((splide) => {
      if (splide instanceof HTMLElement) {
        const splideInstance = new Splide(selectors.splide, {
          type: 'slide',
          autoplay: false,
          rewind: true,
          perPage: 1,
          interval: 6000,
          speed: 2000,
          width: 'auto',
          height: 'auto',
          arrows: false,
          pagination: false
        });

        splideInstance.mount();

        // External arrow binding
        document.querySelector('.stage-arrow--prev').addEventListener('click', () => {
          splideInstance.go('<');
        });

        document.querySelector('.stage-arrow--next').addEventListener('click', () => {
          splideInstance.go('>');
        });
      }
    });
  };

  window.addEventListener('load', init);
})();
